import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import LinkedOrganisationsOverviewCode
	from '@/presentation/components/organisation-linking/linked-organisations-overview/linked-organisations-overview.code';

export default defineComponent({
	components: {
		LoadingWrapper
	},
	setup: () => {
		const code = new LinkedOrganisationsOverviewCode();

		return {
			isLoading: code.isLoading,
			linkedOrganisations: code.linkedOrganisations,
			unlinkOrganisation: code.unlinkOrganisation.bind(code)
		};
	}
});
